angular.module('businessThread', ['core'])
    .constant('BusinessThreadConst', {
        RoleModule: 'ROLE_BUSINESS_THREAD',
        eventUpdate: 'business-thread.updated',
        eventLinkUpdate: 'business-thread-link.updated'
    })
    .factory('BusinessThread', function ($resource) {
        return $resource('/crm/api/business-thread/:id', {id: '@id'}, {
            table: {method: 'GET', isArray: false, url: '/crm/api/business-thread/table'},
            autocomplete: {method: 'GET', isArray: true, url: '/crm/api/business-thread/autocomplete'},
            recentLinked: {method: 'GET', isArray: true, url: '/crm/api/business-thread/recent-linked'},
            update: {method: 'PUT'},
            remove: {method: 'DELETE'},
            links: {method: 'GET', isArray: true, url: '/crm/api/business-thread/:id/links'},
            timeline: {method: 'GET', isArray: true, url: '/crm/api/business-thread/:id/timeline'},
            invoiceTable: {method: 'GET', isArray: false, url: '/crm/api/business-thread/invoice-table'},
            workflowTable: {method: 'GET', isArray: false, url: '/crm/api/business-thread/workflow-table'},
            agreementTable: {method: 'GET', isArray: false, url: '/crm/api/business-thread/agreement-table'},
            agreementOrderTable: {method: 'GET', isArray: false, url: '/crm/api/business-thread/agreement-order-table'},
            link: {method: 'POST', url: '/crm/api/business-thread/:id/links'},
            unlink: {method: 'DELETE', url: '/crm/api/business-thread/:id/links/:linkId', params: {linkId: '@linkId'}},
            toggleFlag: {method: 'PUT', url: '/crm/api/business-thread/:id/links/:linkId/flag', params: {linkId: '@linkId'}},
            resourceLinks: {method: 'GET', isArray: true, url: '/crm/api/business-thread/resource-links'},
            byResource: {method: 'GET', isArray: true, url: '/crm/api/business-thread/by-resource'}
        })
    })
    .service('BusinessThreadService', function ($rootScope, modals, BusinessThread, BusinessThreadConst) {
        const viewState = {}
        const escapeHtml = value => (value || '').toString()
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, '&#039;')

        this.viewStateKey = (view, id) => view && id ? view + ':' + id : null
        this.getViewState = key => key && viewState[key] ? angular.copy(viewState[key]) : {}
        this.saveViewState = (key, state) => {
            if (key) {
                viewState[key] = angular.copy(state || {})
            }
        }

        this.create = data => modals.open('app/business-thread/thread-create-modal.html', 'BusinessThreadCreateController', data, {size: 'md'}, '$ctrl')
        this.edit = item => modals.open('app/business-thread/thread-create-modal.html', 'BusinessThreadCreateController', angular.copy(item), {size: 'md'}, '$ctrl')
        this.selectExisting = data => modals.open('app/business-thread/thread-link-modal.html', 'BusinessThreadLinkController', data, {size: 'md'}, '$ctrl')
        this.timeline = item => modals.open('app/business-thread/thread-timeline-modal.html', 'BusinessThreadTimelineController', angular.copy(item), {size: 'lg'}, '$ctrl')
        this.remove = item => {
            let label = item && item.symbol ? item.symbol : 'wybrany wątek'
            return modals.confirmDelete(label, () => BusinessThread.delete({id: item.id}).$promise
                .then(() => $rootScope.$broadcast(BusinessThreadConst.eventUpdate)))
        }
        this.unlinkResource = item => {
            if (!item || !item.id || !item.threadId) {
                return
            }

            let label = escapeHtml(item.title || (item.resourceId ? '#' + item.resourceId : 'wybrany zasób'))
            return modals.confirm('Czy na pewno odpiąć zasób <strong>' + label + '</strong> od wątku biznesowego?', () => BusinessThread.unlink({
                id: item.threadId,
                linkId: item.id
            }).$promise.then(() => $rootScope.$broadcast(BusinessThreadConst.eventLinkUpdate)))
        }
    })
    .service('BusinessThreadLinkFlagService', function ($rootScope, BusinessThread, BusinessThreadConst, toastr) {
        this.flags = [1, 2, 3, 4]

        this.normalize = flags => {
            let values = angular.isArray(flags) ? flags : (flags != null ? [flags] : [])
            return values
                .filter(flag => flag != null && flag !== '')
                .map(flag => '' + flag)
        }

        this.hasActiveFilter = filters => this.normalize(filters && filters.flags).length > 0

        this.matches = (item, flags) => {
            let normalizedFlags = this.normalize(flags)
            if (!normalizedFlags.length) {
                return true
            }

            let flag = this.value(item)
            return flag != null && normalizedFlags.indexOf('' + flag) !== -1
        }

        this.value = item => item && item.flagMetadata && item.flagMetadata.flag != null ? item.flagMetadata.flag : null

        this.toggleFlag = (item, flag) => {
            const previousFlagMetadata = item ? angular.copy(item.flagMetadata) : null
            if (!item || !item.id || !item.threadId) {
                return
            }

            let currentFlag = this.value(item)
            let isClearingFlag = currentFlag != null && '' + currentFlag === '' + flag
            item.flagMetadata = isClearingFlag ? null : angular.extend({}, previousFlagMetadata || {}, {flag: flag})

            return BusinessThread.toggleFlag({
                id: item.threadId,
                linkId: item.id
            }, {flag: flag}).$promise.then(metadata => {
                item.flagMetadata = metadata && metadata.flag != null ? metadata : null
                toastr.success("Zapisano")
                $rootScope.$broadcast(BusinessThreadConst.eventLinkUpdate)
                return item.flagMetadata
            }).catch(() => {
                item.flagMetadata = previousFlagMetadata
                toastr.error("Nie udało się zapisać flagi")
            })
        }
    })
    .service('BusinessThreadTimelineUi', function ($state, BusinessThreadLinkFlagService) {
        const resourceLabels = {
            LEAD: 'Lead',
            CLIENT: 'Kontrahent',
            DEAL: 'Sprzedaż',
            PROPERTY: 'Lokal',
            PROPERTY_DEAL: 'Obsługa sprzedaży',
            NOTE: 'Notatka',
            TASK: 'Zadanie',
            TODO: 'Zadanie projektowe',
            SERVICE_REQUEST: 'Zgłoszenie serwisowe',
            AGREEMENT: 'Umowa',
            AGREEMENT_ORDER: 'Zlecenie',
            INVOICE: 'Faktura',
            MANUFACTURING_ORDER: 'Zlecenie produkcyjne',
            LEAVE: 'Absencja',
            RENTAL_RESOURCE: 'Obsługa najmu',
            RENTAL_AGREEMENT: 'Umowa najmu',
            PROJECT: 'Projekt',
            WORKFLOW: 'Obieg spraw'
        }
        const resourceStates = {
            AGREEMENT: 'agreementShow',
            AGREEMENT_ORDER: 'agreementShow',
            CLIENT: 'clientShow',
            INVOICE: 'invoiceShowFull',
            LEAD: 'leadShow',
            LEAVE: 'leaveShowFull',
            NOTE: 'noteShow',
            PROJECT: 'projectShowFull',
            PROPERTY: 'propertyShow',
            PROPERTY_DEAL: 'propertyDealShow',
            RENTAL_AGREEMENT: 'rentalAgreementShow',
            RENTAL_RESOURCE: 'rentalResourceShow',
            SERVICE_REQUEST: 'serviceRequestShow',
            TASK: 'taskShow',
            TODO: 'todoShow',
            WORKFLOW: 'workflowShowFull'
        }
        const resourceIcons = {
            LEAD: 'fa-user-plus',
            CLIENT: 'fa-industry',
            DEAL: 'fa-shopping-cart',
            PROPERTY: 'fa-building-o',
            PROPERTY_DEAL: 'fa-home',
            NOTE: 'fa-sticky-note-o',
            AGREEMENT: 'fa-file-text-o',
            AGREEMENT_ORDER: 'fa-file-o',
            INVOICE: 'fa-file-text-o',
            MANUFACTURING_ORDER: 'fa-industry',
            LEAVE: 'fa-calendar-check-o',
            RENTAL_RESOURCE: 'fa-key',
            RENTAL_AGREEMENT: 'fa-file-text-o',
            PROJECT: 'fa-building',
            TASK: 'fa-tasks',
            TODO: 'fa-check-square-o',
            SERVICE_REQUEST: 'fa-wrench',
            WORKFLOW: 'fa-briefcase'
        }
        const detailIcons = {
            date: 'fa-calendar-o',
            direction: 'fa-exchange',
            party: 'fa-address-card-o',
            priority: 'fa-flag-o',
            status: 'fa-circle-o',
            type: 'fa-tag',
            user: 'fa-user-o'
        }

        this.resourceTypes = items => {
            let resourceTypes = []
            ;(items || []).forEach(item => {
                if (item.resourceType && resourceTypes.indexOf(item.resourceType) === -1) {
                    resourceTypes.push(item.resourceType)
                }
            })
            return resourceTypes
        }

        this.resourceTypeCounts = items => {
            let resourceTypeCounts = {}
            ;(items || []).forEach(item => {
                if (item.resourceType) {
                    resourceTypeCounts[item.resourceType] = (resourceTypeCounts[item.resourceType] || 0) + 1
                }
            })
            return resourceTypeCounts
        }

        this.filter = (items, filters, resourceType) => {
            let effectiveFilters = filters || {}
            let dateFrom = normalizeDate(effectiveFilters.dateFrom)
            let dateTo = normalizeDate(effectiveFilters.dateTo)
            let effectiveResourceType = resourceType || effectiveFilters.resourceType
            let search = normalizeSearch(effectiveFilters.search)
            let flags = BusinessThreadLinkFlagService.normalize(effectiveFilters.flags)

            return (items || []).filter(item => matches(item, effectiveResourceType, dateFrom, dateTo, search, flags))
        }

        this.hasActiveFilters = filters => {
            filters = filters || {}
            return !!(normalizeSearch(filters.search) || filters.resourceType || normalizeDate(filters.dateFrom) || normalizeDate(filters.dateTo) || BusinessThreadLinkFlagService.hasActiveFilter(filters))
        }

        this.resourceLabel = type => resourceLabels[type] || type
        this.resourceIcon = type => resourceIcons[type] || 'fa-link'
        this.canOpen = item => item && resourceStates[item.resourceType]
        this.resourceHref = item => this.canOpen(item) ? $state.href(resourceStates[item.resourceType], {id: item.resourceId}) : null
        this.threadHref = thread => thread && thread.id ? $state.href('businessThreadShowFull', {id: thread.id}) : null
        this.timelineHref = thread => thread && thread.id ? $state.href('businessThreadTimelineFull', {id: thread.id}) : null
        this.hasDetails = item => item && item.details && item.details.length
        this.detailClass = detail => detail && detail.kind ? 'business-thread-timeline__detail--' + detail.kind : ''
        this.detailIcon = detail => detailIcons[detail && detail.kind] || 'fa-info-circle'
        this.auditUserTooltip = item => {
            let audit = item && item.audit ? item.audit : {}
            let createdBy = audit.createdBy
            let user = createdBy ? (createdBy.fullName || createdBy.login) : null

            return user
        }

        const matches = (item, resourceType, dateFrom, dateTo, search, flags) => {
            if (resourceType && item.resourceType !== resourceType) {
                return false
            }

            if (!BusinessThreadLinkFlagService.matches(item, flags)) {
                return false
            }

            if (dateFrom || dateTo) {
                let documentDate = normalizeDate(item.documentDate)
                if (!documentDate) {
                    return false
                }
                if (dateFrom && documentDate < dateFrom) {
                    return false
                }
                if (dateTo && documentDate > dateTo) {
                    return false
                }
            }

            if (search && itemSearchText(item).indexOf(search) === -1) {
                return false
            }

            return true
        }

        const itemSearchText = item => {
            let parts = [
                item.resourceType,
                resourceLabels[item.resourceType],
                item.title,
                item.subtitle,
                item.resourceId,
                item.documentDate,
                item.audit && item.audit.createdTime,
                item.audit && item.audit.createdBy && item.audit.createdBy.fullName,
                item.audit && item.audit.createdBy && item.audit.createdBy.login,
                BusinessThreadLinkFlagService.value(item)
            ]

            ;(item.details || []).forEach(detail => {
                parts.push(detail.label)
                parts.push(detail.value)
                parts.push(detail.kind)
            })

            return parts.map(normalizeText).join(' ')
        }

        const normalizeSearch = value => normalizeText(value).trim()

        const normalizeText = value => value != null ? ('' + value).toLowerCase() : ''

        const normalizeDate = value => {
            if (!value) {
                return null
            }
            if (angular.isDate(value)) {
                let month = ('0' + (value.getMonth() + 1)).slice(-2)
                let day = ('0' + value.getDate()).slice(-2)
                return value.getFullYear() + '-' + month + '-' + day
            }
            if (value._isAMomentObject) {
                return value.format('YYYY-MM-DD')
            }
            if (angular.isString(value)) {
                return value.length > 10 ? value.substring(0, 10) : value
            }
            return null
        }
    })
    .run(function (NavbarLeftMenu, BusinessThreadConst) {
        NavbarLeftMenu.add({
            authorities: BusinessThreadConst.RoleModule,
            path: '/business-thread',
            ico: 'fa fa-fw fa-comments-o',
            name: 'business-thread.menu',
            order: 34
        })
    })
    .config(function ($stateProvider, BusinessThreadConst) {
        $stateProvider
            .state('businessThreadList', {
                parent: 'app',
                url: '/business-thread?{page:int}&{size:int}&sort&search',
                data: {
                    authorities: [BusinessThreadConst.RoleModule]
                },
                views: {
                    'content@': 'businessThreadList'
                },
                resolve: {
                    filters: $stateParams => angular.copy($stateParams),
                    page: (BusinessThread, $stateParams) => BusinessThread.table(angular.copy($stateParams)).$promise
                }
            })
            .state('businessThreadShowFull', {
                parent: 'app',
                url: '/business-thread/{id}',
                data: {
                    authorities: [BusinessThreadConst.RoleModule]
                },
                views: {
                    'content@': 'businessThreadShow'
                },
                resolve: {
                    item: (BusinessThread, $stateParams) => BusinessThread.get({id: $stateParams.id}).$promise
                }
            })
            .state('businessThreadTimelineFull', {
                parent: 'app',
                url: '/business-thread/{id}/timeline',
                data: {
                    authorities: [BusinessThreadConst.RoleModule]
                },
                views: {
                    'content@': 'businessThreadTimeline'
                },
                resolve: {
                    thread: (BusinessThread, $stateParams) => BusinessThread.get({id: $stateParams.id}).$promise
                }
            })
    })
